/*
  Page configuration for the Solo — Sales Submission drill-down.

  The figures come from `solo/overview`, `solo/sales/*` and `solo/incidents`
  through `SystemIntelligenceView`; only the page's identity lives here.

  `compact` is what keeps this screen inside a desktop viewport without the
  content column scrolling — see the note on `SystemPageConfig`.
*/

import type { SystemPageConfig } from './system-intelligence'

export const soloPage: SystemPageConfig = {
  service: 'solo',
  title: 'Solo — Sales Submission',
  unit: 'Sales',
  compact: true,
  // Same layout as Aurora: the scope row first, then three tiles — response
  // time, 30-day uptime, sales today — and no period summary row.
  salesTodayHeader: true,
}
